"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redirectLink = (link, isNewTab = false) => {
    const src = link ? link : "#";
    const target = isNewTab ? "_blank" : "_self";
    return window.open(src, target);
};
exports.default = redirectLink;
//# sourceMappingURL=redirect-link.js.map